import styled from "styled-components";

export const StyledSectionWrapper = styled.div`
  position: relative;
  border-bottom: 1px solid rgba(58, 79, 106, 0.1);
  border-top: 1px solid rgba(58, 79, 106, 0.1);
`;

export const StyledSectionContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    & > div {
      width: 50%;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    max-width: 1280px;
    margin: 0 auto;
  }
`;

export const StyledContactFormWrapper = styled.div`
  padding: 40px 8%;

  & > h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    color: #233247;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    padding-right: 0;
    margin-right: 40px;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 70px 90px 105px 65px;
    margin-right: 0;
  }
`;

export const StyledContactForm = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 31px;

  & > input,
  & > textarea {
    border: 1px solid #e5eced;
    box-sizing: border-box;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    padding: 12px 16px 13px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #586981;
  }

  & > button {
    background: #ed3163;
    border-radius: 26px;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    padding: 17px 63px;
  }

  & > textarea {
    padding: 16px;
    height: 160px;
    resize: none;
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    margin-top: 50px;
    & > button {
      width: fit-content;
      align-self: flex-end;
    }
  }
`;

export const StyledContactMap = styled.div`
  position: relative;

  & > h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 21px;
    line-height: 26px;
    padding: 24px 8% 32px;
    color: #233247;
    background: #ffffff;
    position: relative;
  }

  & > img {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    border-left: 1px solid rgba(58, 79, 106, 0.1);
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    & > h3 {
      padding: 62px 50px 24px;
    }
  }
`;

export const StyledContactsContent = styled.div`
  padding: 0 8% 11px;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(58, 79, 106, 0.1);

  & p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.0875px;
    color: #586981;
  }

  & h5 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 10px;
    color: #233247;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    border-bottom: none;
  }
`;
